import SATES from './states'

export default {
  [SATES.NEW] : 'Новое для модерации',
  [SATES.MODERATED] : 'На модерации',
  [SATES.OPERATED] : 'Работа над замечаниями',
  [SATES.ACCEPTED] : 'Опубликовано',
  [SATES.DECLINED] : 'Заблокировано',
}